import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import TermFormat from '../../../modules/crm/helpers/term-format'
import TimeFormat from '../../../modules/crm/helpers/time-format'
import startCase from 'lodash/startCase'

import Button from '@eig-builder/core-ui/Button'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

const InfoItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.black.lighter};
  margin: ${({ theme }) => theme.spacing(2)}px 0;
`

const Title = styled.div`
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
`

const Value = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  overflow-wrap: break-word;
`

const dateKeys = ['canceldate', 'created', 'createdon', 'deleted', 'expires', 'lastpublished', 'modifiedon', 'renewal', 'creationdate']
const priceKeys = ['price', 'cost']

const valueFormatter = (key, value, currencySymbol) => {
  if (key.toLowerCase().includes('term')) {
    return <TermFormat data={value} />
  } else if (dateKeys.includes(key.toLowerCase())) {
    return <TimeFormat date={value} />
  } else if (priceKeys.includes(key.toLowerCase())) {
    return value >= 0 ? currencySymbol + value.toFixed(2) : '-'
  } else if (key.toLowerCase().includes('previewimageurl')) {
    return <>
      <div>
        {value}
      </div>
      <Button
        className='mt-2'
        onClick={() => {
          window.open(value)
        }}
        dataElementLocation={DataElementLocations.BODY}
        dataElementLabel='cst-info-dialog-image-preview'
        dataElementId='cst-info-dialog-image-preview'
      >
        View image preview
      </Button>
    </>
  }
  return value || '-'
}

const InfoContent = ({ currencySymbol, data, propsToHide, disableKeyFormat }) => {
  if (!data) {
    return <div> No information found </div>
  }

  return (
    <>
      {Object.keys(data).map(key => {
        if (typeof data[key] === 'object' && !React.isValidElement(data[key]) && data[key] !== null) {
          const nestedObject = data[key]
          return (
            <InfoItem key={key}>
              <Title> {disableKeyFormat
              ? key
              : startCase(key.replace(/_/g, ' '))}: </Title>
              {Object.keys(nestedObject).map(nestedKey => {
                if (propsToHide && propsToHide.includes(nestedKey)) {
                  return null
                }
                return (
                  <Value key={nestedKey}>
                    {startCase(nestedKey)}: {`${nestedObject[nestedKey]}`}
                  </Value>
                )
              })}
            </InfoItem>
          )
        }
        return (
          <InfoItem key={key}>
            <Title> {startCase(key.replace(/_/g, ' '))}: </Title>
            <Value>
              {valueFormatter(key, data[key], currencySymbol)}
            </Value>
          </InfoItem>
        )
      })}
    </>
  )
}

InfoContent.propTypes = {
  currencySymbol: PropTypes.string,
  data: PropTypes.object,
  propsToHide: PropTypes.array,
  disableKeyFormat: PropTypes.bool
}

export default memo(InfoContent)
